import { useState, cloneElement, ReactElement } from 'react'
import { Fade, Popper } from '@mui/material'
import { Box, Paper, Sx } from '@dhl/theme'

type Props = {
  content: ReactElement
  children: ReactElement
  open: boolean
  // Positioning props:
  width: number
  top: number
  left: number
  arrowMarginLeft: number
  placement: string
}

const classes: Record<string, Sx> = {
  popoverRoot: (theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderRadius: 6,
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.07)',
  }),
  content: (theme) => ({
    padding: theme.spacing(2),
  }),
  arrow: {
    top: -20,
    width: 25,
    height: 25,
    position: 'absolute',
    color: (theme) => theme.palette.background.paper,
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundColor: 'currentColor',
      transform: 'rotate(45deg) translate(4px, 10px)',
    },
  },
}

export const RichTooltip = ({ content, children, open }: Props) => {
  const [arrowRef, setArrowRef] = useState<HTMLSpanElement | null | undefined>(null)
  const [childNode, setChildNode] = useState(null)

  return (
    <div>
      {/** @ts-expect-error TODO Fix, annotation added after React 19 update */}
      {cloneElement(children, { ...children.props, ref: setChildNode })}
      <Popper
        open={open}
        anchorEl={childNode}
        placement="top"
        transition
        sx={{
          zIndex: 2000,
        }}
        modifiers={[
          {
            name: 'preventOverflow',
            enabled: true,
            options: {
              boundariesElement: 'window',
            },
          },
          {
            name: 'arrow',
            enabled: true,
            options: {
              element: arrowRef,
            },
          },
        ]}
      >
        {}
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper sx={classes.popoverRoot}>
              <Box component="span" sx={classes.arrow} ref={setArrowRef} />
              <Box sx={classes.content}>{content}</Box>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  )
}
